'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _Immutable = require('Immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactUtils = require('react-utils');

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _UIForm = require('UIComponents/form/UIForm');

var _UIForm2 = _interopRequireDefault(_UIForm);

var _BookingFormField = require('./BookingFormField');

var _BookingFormField2 = _interopRequireDefault(_BookingFormField);

var _FullNameInput = require('ui-addon-i18n/components/FullNameInput');

var _FullNameInput2 = _interopRequireDefault(_FullNameInput);

var _CustomFormInputs = require('MeetingsLib/components/input/CustomFormInputs');

var _CustomFormInputs2 = _interopRequireDefault(_CustomFormInputs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _React2.default.createClass({
  displayName: 'BookingFormFields',

  propTypes: {
    centerPropertyForm: _React.PropTypes.bool,

    className: _React.PropTypes.string,
    formFields: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    formStateValidation: _React.PropTypes.instanceOf(_Immutable.Map).isRequired,
    formState: _React.PropTypes.instanceOf(_FormState2.default),
    setFormValue: _React.PropTypes.func.isRequired
  },

  renderField: function renderField(fieldName) {
    var _props = this.props,
        formStateValidation = _props.formStateValidation,
        formState = _props.formState,
        setFormValue = _props.setFormValue;


    return _React2.default.createElement(_BookingFormField2.default, {
      fieldName: fieldName,
      validation: formStateValidation.get(fieldName),
      fieldValue: formState.get(fieldName),
      isRequired: true,
      fieldLabel: _I18n2.default.text('prebook.details.field.' + fieldName),
      setFormValue: setFormValue,
      autocomplete: 'on'
    });
  },
  renderCustomFormFields: function renderCustomFormFields() {
    var _props2 = this.props,
        formFields = _props2.formFields,
        formStateValidation = _props2.formStateValidation,
        formState = _props2.formState,
        setFormValue = _props2.setFormValue;


    return _React2.default.createElement(_CustomFormInputs2.default, {
      formFields: formFields,
      formStateValidation: formStateValidation.get('customFormFields'),
      customFormFields: formState.get('customFormFields'),
      onCustomFormFieldChange: setFormValue
    });
  },
  renderNameFields: function renderNameFields() {
    return _React2.default.createElement(_FullNameInput2.default, {
      direction: 'row',
      wrap: 'wrap',
      givenNameInput: this.renderField('firstName'),
      familyNameInput: this.renderField('lastName')
    });
  },
  render: function render() {
    var className = (0, _reactUtils.classNames)('p-x-1 p-bottom-4', {
      'p-x-15': this.props.centerPropertyForm
    });
    return _React2.default.createElement(
      _UIForm2.default,
      { className: className },
      this.renderNameFields(),
      this.renderField('email'),
      this.renderCustomFormFields()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/input/BookingFormFields.js
// module id = 478
// module chunks = 0